import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GridPagerService {
	pagerInitialized: boolean = false;
	isLoading: boolean = false;

	clickNextEvent = new Subject();
	clickPreviousEvent = new Subject();
	clickPageEvent = new Subject();
	refreshPagingEvent = new Subject();

	dataReloadedEvent = new Subject();

	constructor() { 
		this.dataReloadedEvent.subscribe((data)=>{
			
			let interval = setInterval(()=>{
				if(this.pagerInitialized==true){
					clearInterval(interval);

					this.refreshPagingEvent.next(data);
				}
			}, 500);

		});		
	}
}
